import { PermissionValue, UserPermission, UserType } from "../public-api";

export interface UserSessionResponse {
  user_id: string;
  usr_first_name: string;
  usr_last_name: string;
  usr_team_track_id: string;
  usr_email: string;
  is_logged_in: boolean;
  usr_role_track_id: string;
  usr_customer_track_id: string;
  user_type: UserType;
  have_permissions: Permission[];
  can_create: boolean;
  can_approve: boolean;
  can_support: boolean;
  can_view: boolean;
}

export interface LoginBody {
  usr_email: string;
  usr_password: string;
}

export interface ProfileDetail {
  aniversary: Date | string;
  joining: Date | string;
  user_id: string;
  usr_address: string;
  usr_address2: string,
  usr_country: string,
  usr_state: string,
  usr_city: string,
  usr_zipcode: string,
  usr_archive_status: string;
  usr_designation: string;
  usr_dob: Date | string;
  usr_email: string;
  usr_empID: string;
  usr_mobile: string;
  first_name: string;
  last_name: string;
  usr_photo: string;
  usr_skype_id: string;
  usr_idproof: string;
  usr_manager_id: string;
  usr_role_track_id: string;
  permissions: Permission[];
  organisation: string;
  user_department: string;
  manager_first_name?: string;
  manager_last_name?: string;
}

export interface Permission {
  permissions: UserPermission;
}
